/* Reducer CITY */

const cityJSON = localStorage.getItem("city")
const DEFAULT = cityJSON ? JSON.parse(cityJSON) : null

const city = (state = DEFAULT, action) => {

    switch (action.type) {

        case 'SET_CITY':
            const city = action.payload
            localStorage.setItem("city", JSON.stringify(city))
            return city

        case 'REMOVE_CITY':
            localStorage.removeItem("city")
            return null

        default:
            return state
    }
}

export default city
